var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var Svg1 = function Svg1(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f67868cd-aad4-4004-b580-0a057f764a70",
    "data-name": 1,
    width: 52.68,
    height: 69.99,
    viewBox: "0 0 52.68 69.99",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.67,67.97H24.98V21.09H9V12a60.442,60.442,0,0,0,8.86-.84A12.43,12.43,0,0,0,24.42,7.6a11.614,11.614,0,0,0,2.62-4.88A11.4,11.4,0,0,0,27.56,0H38.67Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.05,2.72A11.789,11.789,0,0,1,29.43,7.6a12.506,12.506,0,0,1-6.56,3.56,57.706,57.706,0,0,1-8.86.84v9.09H29.99V67.97H43.68V0H32.57A10.993,10.993,0,0,1,32.05,2.72ZM33.47,1a17.611,17.611,0,0,1-.46,1.99h0a12.757,12.757,0,0,1-2.86,5.29M33.47,1h9.2V66.97H30.98V21.09a1,1,0,0,0-1-1H15V12.95a56.152,56.152,0,0,0,8.08-.82m0,0a13.485,13.485,0,0,0,7.07-3.85Z",
    style: {
      fill: "currentColor",
      fillRule: "evenodd"
    }
  }));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg1, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/1.337d355d.svg";
export { ForwardRef as ReactComponent };